/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module plpLazyLoad
 */

 import $ from 'jquery';
 import get from 'lodash/get';
 import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
 import mergeOptions from 'styleguide/lib/merge-options'
 import throttle from 'lodash/throttle';
 
 export const PLUGIN_NAME = 'plpLazyLoad';
 export const DEFAULTS = {
   loadAfterCallback: function() {}
 };
 
 const CLICK = 'click';
 const ANCHOR = 'a';
 const HTML = 'html';
 const LOAD = 'load';
 const PLPSESSIONKEY = "plpSession";
 const MAXSESSION = 21;
 
 /**
 * This will check if current session exists
 * If not, create an array
 * If exists, get the object from the session
 */
 const getPositionFromTopOnClick = () => {
   $(HTML).on(CLICK, ANCHOR, function () {
     let plpSessionArray = sessionStorage.getItem(PLPSESSIONKEY);
     plpSessionArray = JSON.parse(plpSessionArray) || [];
     // Gets a new JSON data with current url and position
     const plpSessionUrlPosition = {
       currentUrl: window.location.href,
       currentPosition: window.scrollY
     };
     if(plpSessionArray.length > MAXSESSION) {
       plpSessionArray.shift();
     } else {
       plpSessionArray.push(plpSessionUrlPosition)
     }
     // Push the object to the array
     sessionStorage.setItem(PLPSESSIONKEY, JSON.stringify(plpSessionArray));
   });
 };
 
 /**
 * Initializes lazy loading for plp
 * @param  {jQuery} $el - The ul container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options*
 */
 const lazyLoadPlp = ($el, options = {}) => {
   const $window = $(window)
   getPositionFromTopOnClick();
   const lazyAnimation = $(progressBarHTML());
 
   $.ajax({
     url: options.lazyLoadUrl,
     cache: false,
     success: function (result) {
       $el.parent().css('min-height', '');
       $el.append(result);
       options.loadAfterCallback();
       $window.off("scroll.plp-lazy-load");
       $('.pagination-alternative').show()
       lazyAnimation.hide();
       /*
       * checks if user interact with the browser back button
       * this if statement will get the session and most recent position from the object
       */
       const windowPerformance = get(window, 'performance');
       if (windowPerformance && windowPerformance.navigation.type == windowPerformance.navigation.TYPE_BACK_FORWARD) {
         /* gets the object array from plpSession */
         const sessionObj = JSON.parse(sessionStorage.getItem(PLPSESSIONKEY));
         /* removes the last object from the array but also gets the values */
         const lastObj = sessionObj.pop();
         /*  scrolls to the position */
         $(document).scrollTop(lastObj.currentPosition);
         /* set the new session again */
         sessionStorage.setItem(PLPSESSIONKEY, JSON.stringify(sessionObj));
       }
     }
   });
 
   $window.on("scroll.plp-lazy-load", throttle(()=> {
     const windowHeight = $window.height();
     const scrollPosY = $window.scrollTop() + windowHeight;
     const targetTop = $el.offset().top;
     if(scrollPosY >= targetTop) {
       $el.after(lazyAnimation);
       $window.off("scroll.plp-lazy-load");
       $('.pagination-alternative').hide()
     }
   }, 10));
 }
 const progressBarHTML = () => {
   return `<div id="js-trigger-load-plp" class="u-padding-b--xl">
       <div class="progress-bar__lazy u-margin--center">
         <div class="u-padding-a--xl">
           <div class="progress-bar">
             <div class="u-screen-reader">
               Products are loading
             </div>
           </div>
         </div>
       </div>
     </div>`
 }
 
 
 /**
 * Initializes plpLazyLoad.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the plpLazyLoad
 * @see DEFAULTS
 */
 export default function plpLazyLoad(el, options = {}) {
   const $el = $(el);
   const opts = mergeOptions(DEFAULTS, options, $el);
   lazyLoadPlp($el, opts);
 }
 
 registerJQueryPlugin(PLUGIN_NAME, plpLazyLoad);
 


// WEBPACK FOOTER //
// ./src/scripts/modules/plp-lazy-load.js